import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import {
  CreateTourBooking,
  FindMany,
  FindOne,
  PaginateResult,
  TourBooking,
  UpdateTourBooking,
} from '@univacity/shared/types';
import { Observable } from 'rxjs';
import { Configuration } from '../config';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class TourBookingService {
  baseUrl: string;

  constructor(
    private http: HttpClient,
    private config: Configuration,
    private auth: AuthService
  ) {
    this.baseUrl = this.config.apiMainUrl + '/tour/booking';
  }

  create(booking: CreateTourBooking): Observable<TourBooking> {
    return this.http.post<TourBooking>(this.baseUrl, booking);
  }

  find(query: FindMany = {}): Observable<PaginateResult<TourBooking>> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<PaginateResult<TourBooking>>(this.baseUrl, { params });
  }

  findOne(id: string, query: FindOne = {}): Observable<TourBooking> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<TourBooking>(`${this.baseUrl}/${id}`, { params });
  }
  findByReference(
    reference: string,
    lastName: string,
    query: FindOne = {}
  ): Observable<TourBooking> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<TourBooking>(
      `${this.baseUrl}/${reference}/${lastName}`,
      { params }
    );
  }

  update(id: string, booking: UpdateTourBooking): Observable<TourBooking> {
    return this.http.patch<TourBooking>(`${this.baseUrl}/${id}`, booking);
  }

  cancel(id: string): Observable<TourBooking> {
    return this.http.delete<TourBooking>(`${this.baseUrl}/${id}/cancel`);
  }
  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
